/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Discount/Content"
  
}) {
let paymentPlanFinalDiscountPercentageValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'final_discount.percentage',
})
let constantData = '% off payor share'
let aggregateData = fromAggregate.join(paymentPlanFinalDiscountPercentageValueData, constantData)
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="green"
 alignSelf="center"
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 data="payment_plan.final_discount.percentage"
 data="'% off payor share'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
 size="tiny"
 color={dtColorsGreen800}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}